import { Component, Input } from '@angular/core';
import { Location } from '@angular/common';
import { BreadcrumbItem } from '../breadcrumb/breadcrumb.component';

@Component({
    selector: 'lokos-page-header',
    templateUrl: './page-header.component.html',
    styleUrl: './page-header.component.scss',
    standalone: false,
})
export class PageHeaderComponent {
    @Input() title = '';
    @Input() breadcrumbs: BreadcrumbItem[] = [];

    constructor(private location: Location) {}

    goBack(): void {
        this.location.back();
    }
}
